import ChekinAPI from '../ChekinAPI';

export const dynamicRoute = <T>({regular, sdk}: {regular: T; sdk: T}) => {
  return {
    regular,
    sdk,
  }[ChekinAPI.mode];
};
